export enum ETenderState {    
    Undefined,
    Published,
    Draft
}